// extracted by mini-css-extract-plugin
module.exports = {"button":"MenuButton_button_2CGEg","small":"MenuButton_small_3c1Cb","mobileButton":"MenuButton_mobileButton_2hO8c"};